// extracted by mini-css-extract-plugin
export var brand = "_6r-9";
export var compact = "_6r-6";
export var extraSmall = "_6r-7";
export var icon = "_6r-0";
export var large = "_6r-4";
export var light = "_6r-1";
export var medium = "_6r-5";
export var outline = "_6r-b";
export var primaryDark = "_6r-a";
export var primaryLight = "_6r-8";
export var primaryModern = "_6r-c";
export var success = "_6r-2";
export var successSolid = "_6r-3";